<template>
  <div>
    <router-link
      :to="{
        name: 'industrial_group_order_details',
        query: { branchId: data.branchId },
      }"
    >
      <button>View Details</button>
    </router-link>
  </div>
</template>

<script>
import configObject from "../../../config";
import Jquery from "jquery";
let $ = Jquery;
export default {
  data() {
    return {
      data: {},
    };
  },
};
</script>

<style scoped>
button {
  background-color: #370f70;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
}
</style>
